import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Lenis from "lenis";
import LandingPage from "@/pages/LandingPage";
import Admin from "@/pages/Admin";
import AuthCallback from "@/pages/AuthCallback";
import PageEditor from "@/pages/PageEditor";
import PagePreview from "@/pages/PagePreview";
import AdminRequests from "@/pages/AdminRequests";
import AdminReviews from "@/components/admin/AdminReviews";
import { Navigate } from "react-router-dom";

function AppRouter() {
  const location = useLocation();
  useEffect(() => { if (location.pathname.startsWith("/admin")) window.scrollTo(0, 0); }, [location.pathname]);
  // Detect session_id synchronously during render (prevents race conditions)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/admin" element={<Admin />}>
        <Route index element={<PageEditor />} />
        <Route path="preview" element={<PagePreview />} />
        <Route path="requests" element={<AdminRequests />} />
        <Route path="reviews" element={<AdminReviews />} />
        <Route path="gallery" element={<Navigate to="/admin?panel=gallery" replace />} />
      </Route>
      <Route path="*" element={<LandingPage />} />
    </Routes>
  );
}

function SmoothScroll() {
  const location = useLocation();
  useEffect(() => {
    if (location.pathname.startsWith("/admin")) return;
    const lenis = new Lenis({ lerp: 0.09 });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, [location.pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll />
        <AppRouter />
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
